import { useContext } from 'react';
import dynamic from 'next/dynamic';
import { dateTimeFormatLetters, formatLocale } from 'libs';
import { LanguageContext } from 'context/Language';
import { Article } from 'types';

const Col = dynamic(() => import('components/Grid/Col'));
const Row = dynamic(() => import('components/Grid/Row'));
const SliderCard = dynamic(() => import('components/SliderCard'));

interface SliderCardsProps {
  data?: Article[];
}

const SliderCards: React.FC<SliderCardsProps> = ({ data }) => {
  const { lang } = useContext(LanguageContext);

  return (
    <>
      {data && (
        <Row g={4}>
          {data.map((el, index) => (
            <Col key={index} size={12} sm={6} md={4}>
              <SliderCard
                tags={el?.tags}
                date={formatLocale(el?.publish_date, dateTimeFormatLetters, lang)}
                img={el?.background}
                href={`/${lang}/news/${el?.i18n[lang]?.slug}`}
                text={el?.i18n[lang]?.preview ? el?.i18n[lang]?.preview : el?.i18n[lang]?.title}
              />
            </Col>
          ))}
        </Row>
      )}
    </>
  );
};

export default SliderCards;
